import { merge } from '../../../helper';

import isEmptyObject from '../../../general/isEmpty/isEmptyObject';

import add from './add';

// ----------------------------------------------------------------------------

function data(element: HTMLElement, config: Record<string, any> = {}): any[] {
    const defConfig: Record<string, any> = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const list: any[] = [];

    // Foreach Data
    for (const item of defConfig.data) {
        // If item is object
        if (!isEmptyObject(item)) {
            // Create element (dropdown item)
            const dropdownItem = add({
                merge: {
                    ...defConfig,
                    ...item,
                },
            });
            element.appendChild(dropdownItem.element);

            // List Push
            list.push(dropdownItem.element);
        }
    }

    // Return
    return list;
}

// ----------------------------------------------------------------------------

export default data;
